




  document.addEventListener('DOMContentLoaded', function() {
    const customizeBtn = document.querySelector('.itg-cstm-prod-form');
    if (!customizeBtn) return;

    customizeBtn.addEventListener('click', function() {
      const productTitle = this.getAttribute('data-title'); // get product title

      // Wait for the Globo floating button
      const checkButton = setInterval(() => {
        const globoBtn = document.querySelector('.globo-formbuilder .floating-button');
        if (globoBtn) {
          clearInterval(checkButton);
          globoBtn.click(); // open the Globo form

          // Wait for the form input to appear
          const checkInput = setInterval(() => {

            const inputFieldWrapper = document.querySelector('.itg-custom-product-form .material_outlined-label');
            const inputField = document.querySelector('.itg-custom-product-form .globo-form-input input');
            console.log(inputField , "input value");
            
            if (inputField) {
              clearInterval(checkInput);
              console.log(productTitle , "value added in input field");
              inputField.value = productTitle; 
              inputField.setAttribute("value", productTitle) ;

              inputField.setAttribute("disabled", "disabled");
              inputField.style.pointerEvents = "none"; // optional extra protection

              console.log("inputFieldWrapper" , inputFieldWrapper );

              inputFieldWrapper.classList.add("gfb__label__filled");

            }
          }, 200);

          setTimeout(() => clearInterval(checkInput), 5000);
        }
      }, 200);

      setTimeout(() => clearInterval(checkButton), 5000);
    });
  });






document.addEventListener("DOMContentLoaded", function () {
  const swiperEl = document.querySelector(".product__media-list-mobile-only.swiper");
  const desktopVideos = document.querySelectorAll("video.product_media_lazy-video"); // used for desktop (above 750px)

  // --- Shared Functions ---
  function playVideo(video) {
    const sources = video.querySelectorAll("source[data-src]");
    sources.forEach(source => {
      if (source.dataset.src) {
        source.src = source.dataset.src;
        source.removeAttribute("data-src");
      }
    });
    video.load();
    video.play().catch(() => {}); // prevent errors if autoplay blocked
  }

  function pauseAllVideos(videos) {
    videos.forEach(v => v.pause());
  }

  // --- Case 1: Mobile (Swiper active) ---
  if (window.innerWidth <= 750 && swiperEl && typeof Swiper !== "undefined") {
    const swiper = swiperEl.swiper || new Swiper(swiperEl);
    const swiperVideos = swiperEl.querySelectorAll("video.product_media_lazy-video");

    swiper.on("slideChange", function () {
      pauseAllVideos(swiperVideos);
      const activeSlide = swiper.slides[swiper.activeIndex];
      const video = activeSlide.querySelector("video.product_media_lazy-video");
      if (video) playVideo(video);
    });

    swiper.on("init", function () {
      const activeSlide = swiper.slides[swiper.activeIndex];
      const video = activeSlide.querySelector("video.product_media_lazy-video");
      if (video) playVideo(video);
    });

    if (swiper.initialized) {
      const activeSlide = swiper.slides[swiper.activeIndex];
      const video = activeSlide.querySelector("video.product_media_lazy-video");
      if (video) playVideo(video);
    }

  // --- Case 2: Desktop (Grid, no Swiper) ---
  } else {
    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          const video = entry.target;
          if (entry.isIntersecting) {
            playVideo(video);
            obs.unobserve(video); // load only once
          }
        });
      }, { threshold: 0.5 });

      desktopVideos.forEach(video => observer.observe(video));
    } else {
      // fallback if IntersectionObserver not supported
      desktopVideos.forEach(video => playVideo(video));
    }
  }
});

